import React from 'react';
import { CheckCircle, Warning, WarningCircle } from '@phosphor-icons/react';
import { CustomIcon } from '../CustomIcon/CustomIcon.component';

export const WarningCircleAlertIcon = (
  <CustomIcon
    icon={WarningCircle}
    color="#D92D20"
    boxSize={5}
    $bgColor="#FEE4E2"
    $borderColor="#FEF3F2"
    $isRounded
  />
);

export const WarningAlertIcon = (
  <CustomIcon
    icon={Warning}
    color="#D92D20"
    boxSize={5}
    $bgColor="#FEF0C7"
    $borderColor="#FFFAEB"
    $isRounded
  />
);

export const CheckCircleAlertIcon = (
  <CustomIcon
    icon={CheckCircle}
    color="#039855"
    boxSize={5}
    $bgColor="#D1FADF"
    $borderColor="#ECFDF3"
    $isRounded
  />
);
